import styled from '@emotion/styled';
import { gutters } from 'app/spacing';
import KizenTypography from 'app/kizentypo';
import Card from 'components/Card/Card';
import { fontSizes } from 'app/typography';

export const Container = styled.div`
  max-width: 820px;
  width: auto;
  margin: 10px auto;
  background-color: unset;
  & > div {
    margin: 20px auto;
    max-width: 100%;
  }
`;

export const StyledHeader = styled(KizenTypography)<{
  children: any;
  type?: string;
  margin?: string;
}>`
  text-align: center;
  width: 100%;
  margin: 0;
  margin-top: calc(5px - 2px);
  margin-bottom: calc(2 * ${gutters.standard} - 7px);
`;

export const StyledCard = styled(Card)`
  padding: ${gutters.spacing(4)}px;
`;

export const StyledInfoBox = styled.div`
  padding: ${gutters.spacing(2, -2)}px ${gutters.spacing(3, -3)}px;
  border-radius: 4px;
  background-color: var(--color-feedback-info-bg);
`;

export const StyledParagraph = styled.p`
  margin: 0;
  font-size: ${fontSizes.text};
  line-height: 110%;
  color: var(--color-font-primary);
`;
